


































import { mdiCheck, mdiEarth } from '@mdi/js';
import Vue from 'vue';
import Navigation from './Navigation.vue';

export default Vue.extend({
    name: 'Header',
    components: { Navigation },
    props: {
        title: {
            type: String,
            default: 'CREACE',
        },
        image: {
            type: String,
            default: null,
        },
    },
    data: () => ({
        drawer: false,
        icons: {
            earth: mdiEarth,
            check: mdiCheck,
        },
    }),
    computed: {
        locales() {
            return this.$i18n.availableLocales;
        },
    },
    methods: {
        setLocale(locale: string) {
            this.$i18n.locale = locale;
        },
        isActive(locale: string) {
            return this.$i18n.locale === locale;
        },
    },
});
